import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { MetaService } from '../../services/meta/meta.service';

@Component({
  selector: 'app-share-result',
  templateUrl: './share-result.component.html',
  styleUrls: ['./share-result.component.scss']
})
export class ShareResultComponent implements OnInit {
  public content: Entry<any>;
  public testResult: any;

  constructor(private route: ActivatedRoute, private meta: MetaService) {
    this.content = route.snapshot.data.content;

    const paramsMap = this.route.snapshot.queryParamMap;

    if (this.content && this.content.fields.seo) {
      const oilBarrels = parseInt(paramsMap.get('oil_barrels'));
      this.content.fields.seo.fields.title = this.getTitle(oilBarrels);
      this.meta.updateMetaTags(this.content.fields.seo);
    }

    this.testResult = {
      co2e: paramsMap.get('co2e'),
      categoryCO2e: [
        {
          co2e: parseInt(paramsMap.get('co2e_living')),
          category: { icon: 'icon-test-living.svg' }
        },
        {
          co2e: parseInt(paramsMap.get('co2e_travel')),
          category: { icon: 'icon-test-travel.svg' }
        },
        {
          co2e: parseInt(paramsMap.get('co2e_food')),
          category: { icon: 'icon-test-food.svg' }
        },
        {
          co2e: parseInt(paramsMap.get('co2e_shopping')),
          category: { icon: 'icon-test-shopping.svg' }
        }
      ]
    };
  }

  getTitle(oilBarrels) {
    const title = this.content.fields.seo.fields.title;
    return title.replace('{{oilBarrels}}', oilBarrels);
  }

  ngOnInit() {}
}
